export default __webpack_public_path__ + "static/media/Mm.31712678.wav";